/**
 * The mirror's footer disclosure (Sprint 1.9.9 D13, D32).
 *
 * The payload's disclaimer, once, behind "About these readings" and closed by
 * default; the full sentence also stays on Report. The aside is History's and
 * Report's element, `aria-label="Disclaimer"`, so the disclaimer-pairing test
 * reads it the way it reads theirs. `disclaimer` is the payload's string,
 * verbatim, and the only thing in here that is not layout.
 */
export function AboutReadings({ disclaimer }: { disclaimer: string }) {
  return (
    <details className="home-about" data-testid="home-about">
      <summary>About these readings</summary>
      <aside className="disclaimer" aria-label="Disclaimer">
        {disclaimer}
      </aside>
    </details>
  )
}
